<template>
	<div class="modal fade" id="modal-cadastro-user">
		<div class="modal-dialog modal-xl">
			<div class="modal-content">
				
				<div class="modal-header">
					<h4 class="modal-title">Usuário</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>

				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<img :src="logotipo" style="width: 16%; margin-left: 42%;">
						</div>
					</div>

					<div class="row">
				        <div class="col-lg-6">
				            <div class="form-group">
				                <label>Nome</label>
				                <input type="text" class="form-control form-control-sm" :class="[(user.name) ? '' : incomplete]" v-model="user.name">
				            </div>
				        </div>

				        <div class="col-lg-6">
				             <div class="form-group">
				                <label>Email</label>
				                <input type="text" class="form-control form-control-sm" :class="[(user.email) ? '' : incomplete]" v-model="user.email">
				            </div>
				        </div>
				    </div>

				    <div class="row">
				    	<div v-if="$store.state.user.type == 3" class="col-lg-4">
					        <div class="form-group">
					           	<label>Unidade</label>
				                <select class="form-control form-control-sm" :class="[(user.unidade_id) ? '' : incomplete]" v-model="user.unidade_id">
				                	<option value="0" disabled>Unidade</option>
					                <option v-for="uni in unidades.result" :value="uni.id">{{ uni.nome }}</option>
				                </select>
					        </div>
				        </div>

				        <div class="col-lg-4">
				            <div class="form-group">
				                <label>Tipo</label>
				                <select id="tipo" class="form-control form-control-sm" :class="[(user.type) ? '' : incomplete]" v-model="user.type">
				                	<option value="0" disabled>Tipo de usuário</option>
				                	<option value="1">Usuário</option>
				                	<option value="2">Administrador</option>
				                	<option v-if="$store.state.user.type == 3" value="3">Super Administrador</option>
				                </select>
				            </div>
				        </div>

				    	<div class="col-lg-4">
				            <div class="form-group">
				                <label>Matrícula</label>
				                <input type="text" class="form-control form-control-sm" :class="[(user.matricula) ? '' : incomplete]" v-model="user.matricula">
				            </div>
				        </div>
				    </div>

				    <div class="row" v-if="action == 'add'">
				        <div class="col-lg-4">
				    		<div class="form-group">
				                <label>Usuário</label>
				                <input type="text" class="form-control form-control-sm" :class="[(user.username) ? '' : incomplete]" v-model="user.username">
				            </div>
				    	</div>

				    	<div class="col-lg-4">
				    		<div class="form-group">
				                <label>Senha</label>
				                <input type="password" class="form-control form-control-sm" :class="[(password.senha) ? '' : incomplete], pwd_verify" v-model="password.senha">
				            </div>
				    	</div>

				    	<div class="col-lg-4">
				    		<div class="form-group">
				                <label>Repetir senha</label>
				                <input type="password" class="form-control form-control-sm" :class="[(password.resenha) ? '' : incomplete], pwd_verify" v-model="password.resenha">
				            </div>
				    	</div>
				    </div>
				</div>

				<input type="hidden" v-model="user.status">

				<div class="modal-footer">
					<button class="btn btn-danger btn-sm"  v-if="action == 'view'" @click="deletar"  >DELETAR</button>
					<button class="btn btn-warning btn-sm" v-if="action == 'view'" @click="atualizar">ATUALIZAR</button>
					<button class="btn btn-success btn-sm" v-if="action == 'add'"  @click="adicionar">INSERIR</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import api   from "@/mixins/api.js"
	import alert from "@/components/Tools/alert.vue"

	export default {
		name: "view-user",
		props: [ 'user', 'password', 'action' ],
		mixins: [api],

		data: () => { return {
			incomplete: false,
			pwd_verify: "",
			unidades: {},

			alert: {
				type: "",
				name: "alert-modal-user",
				msg : ""
			}
		}},

		async created() {
			this.unidades = await this.GET("Unidade")
		},

		computed: {
			logotipo() { return this.$store.state.config.logotipo }
		},

		methods: {
			async adicionar() {
				//
				//	Verifica se todos os dados foram preenchidos
				//
				if(this.$store.state.user.type != 3)
				{
					this.user.unidade_id = this.$store.state.user.unidade_id;
				}
				if ( !this.user.name || !this.user.email || !this.user.unidade_id || !this.user.type || !this.user.username || !this.password.senha || !this.password.resenha ) 
				{
					window.alert("Preencha os campos obrigatórios!")
					this.incomplete = "focus"
				}

				else 
				{
					//
					//	Verifica se as senhas são iguais
					//
					if ( this.password.senha == this.password.resenha ) 
					{
						this.user.password = this.password.senha
						this.user.status = "0"

						//	Efetua a requisição
						const response = await this.POST("User", this.user)
						
						if ( response.status == "success") this.$emit("alert", { status: "success", result: "Usuário adicionado com sucesso."} )
						else window.alert(response.result)
					}

					else
					{
						window.alert("Senhas não são iguais!")
						this.pwd_verify = "focus"
					}
				}
			},

			async atualizar() {
				//
				//	Verifica se todos os dados foram preenchidos
				//
				if ( !this.user.name || !this.user.email || !this.user.unidade_id || !this.user.type ) 
				{
					window.alert("Preencha os campos obrigatórios!")
					this.incomplete = "focus"
				}

				else 
				{
					const response = await this.PUT("User", this.user)
					
					if ( response.status == "success") this.$emit("alert", { status: "success", result: "Usuário atualizado com sucesso com sucesso."} )
					else window.alert(response.result)
				}
			},

			async deletar() {
				if ( window.confirm(`Isso irá deletar o usuário ${this.user.nome} permanentemente.`) ) {
					const response = await this.DELETE('User', this.user.id)
					if ( response.status == "success") this.$emit("alert", response )
					else window.alert(response.result)
				}
			}
		}
	}
</script>

<style scoped>
</style>
